module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_02_1280_1280_th-2e8efb7d8617ae1e1700928dee950f6a.jpg";